import tmhRequest from '@/config/tmhRequest'

export default {

  createApplyStoreCard: function (data) {
    return tmhRequest({
      url: '/apply/tmh/applystorecard/createapplystorecard',
      method: 'post',
      params: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/apply/applystorecard.js